import { EmployeePto } from "interfaces/Mueller.Business.Models";
import { HTTP_DELETE, HTTP_GET, HTTP_POST, WebApiRequest } from "tools/webservice";

export const getEmployeePto = (employeeId: number, mountedRef: React.RefObject<boolean>, successCallback: (ptos: EmployeePto[]) => void, errorCallback?: (error: any) => void) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/employees/${employeeId}/pto`,
  mountedRef,
  successCallback,
  errorCallback
});

export const addEmployeePto = (employeeId: number, mountedRef: React.RefObject<boolean>, payload: EmployeePto, successCallback: (ptos: EmployeePto[]) => void, errorCallback?: (error: any) => void) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/employees/${employeeId}/pto`,
  mountedRef,
  payload,
  successCallback,
  errorCallback
});

export const deleteEmployeePto = (ptoId: number, mountedRef: React.RefObject<boolean>, successCallback: () => void, errorCallback?: (error: any) => void) => WebApiRequest({
  method: HTTP_DELETE,
  endpoint: `/employees/pto/${ptoId}`,
  mountedRef,
  successCallback,
  errorCallback
});